module.exports = __webpack_public_path__ + "static/media/arrow-up.80054458.svg";